import { Brightness4, DarkMode, LightMode } from '@mui/icons-material';
import {
  Button,
  Paper,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export enum Themes {
  SYSTEM = 'system',
  LIGHT = 'light',
  DARK = 'dark',
}

export default function Profile() {
  const { t, i18n } = useTranslation();

  const onLanguageChange = () => {
    const currentLanguage = localStorage.getItem('language');
    const nextLanguage = currentLanguage === 'en' ? 'hu' : 'en';
    localStorage.setItem('language', nextLanguage);
    i18n.changeLanguage(nextLanguage);
    moment.locale(nextLanguage);
  };

  const userTheme = localStorage.getItem('theme') as Themes | null;
  const [theme, setTheme] = useState<Themes>(userTheme ?? Themes.SYSTEM);

  const onUpdateTheme = (
    _event: React.MouseEvent<HTMLElement>,
    newTheme: Themes,
  ) => {
    setTheme(newTheme);
    if (newTheme === Themes.SYSTEM) {
      localStorage.removeItem('theme');
    } else {
      localStorage.setItem('theme', newTheme);
    }
    window.dispatchEvent(new Event('storage'));
  };

  return (
    <Paper
      sx={{
        padding: theme => theme.spacing(4),
        mt: theme => theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box display="flex" alignItems={'center'}>
        <Typography variant="body1" gutterBottom>
          {t('profile.languageSelector')}
        </Typography>
        <Button sx={{ ml: 1, mb: 1, mt: 1 }} onClick={onLanguageChange}>
          {localStorage.getItem('language')?.toLocaleUpperCase() ?? 'HU'}
        </Button>
      </Box>

      <Box display="flex" alignItems={'center'}>
        <Typography variant="body1" gutterBottom sx={{ mr: 1 }}>
          {t('profile.theme')}:
        </Typography>
        <ToggleButtonGroup value={theme} exclusive onChange={onUpdateTheme}>
          <ToggleButton value={Themes.SYSTEM}>
            <Brightness4 sx={{ mr: 1 }} />
            {t('profile.systemTheme')}
          </ToggleButton>
          <ToggleButton value={Themes.LIGHT}>
            <LightMode sx={{ mr: 1 }} />
            {t('profile.lightTheme')}
          </ToggleButton>
          <ToggleButton value={Themes.DARK}>
            <DarkMode sx={{ mr: 1 }} />

            {t('profile.darkTheme')}
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Paper>
  );
}
